import React, { useState } from "react";
import { fnGetValueByKey } from "../../helpers/functions";
import { Button } from "reactstrap";
import BizinBackend from "../../helpers/bizin_helper";
import { useSelector } from "react-redux";
import useGetCsrfToken from "../../Hooks/useGetCsrfToken";

const ButtonTransactionFavorite = ({ data }) => {
  let isFavorite = fnGetValueByKey(data, "PROCEDURE_EXTRACAO_RESULTSET");

  const user = useSelector((state) => state.login.user);
  const csrfToken = useGetCsrfToken();

  try {
    if (Array.isArray(JSON.parse(isFavorite)))
      isFavorite = JSON.parse(isFavorite)[0];
  } catch (error) {
    console.log("Parâmetro favorito not found: ", error);
  }

    const [isFavorited, setIsFavorited] = useState(isFavorite?.Favorito === 'S' || false)
    const [isLoading, setIsLoading] = useState(false)

  const handleActionFavorited = async () => {
    let procName = fnGetValueByKey(data, "PROCEDURE");
    let procParams = JSON.parse(fnGetValueByKey(data, "PROCEDURE_PARAM"));
    setIsLoading(true)
    try {
      await BizinBackend.executeProcedure(Object.assign({}, procParams), procName, csrfToken, user?.access_token);
      setIsFavorited(!isFavorited)
    } catch (error) {
      console.warn(`Erro to call proc [${procName}]`, error);
    } finally {
      setIsLoading(false)
    }
  };

  return (
    <Button
        disabled={isLoading}
      onClick={handleActionFavorited}
      className="bg-transparent border-0 p-0 m-0"
    >
      <i
        class={`${
          isFavorited ? "fa-solid" : "fa-regular"
        } fa-heart font-size-24 text-primary-dark`}
      ></i>
    </Button>
  );
};

export default ButtonTransactionFavorite;
